<template>
  <loading-page v-if="loading" />
  <form-wrapper
    v-else
    full-width
  >
    <template v-slot:body>
      <validation-observer ref="validation">
        <div class="col-12 col-md-8 col-lg-6 mx-auto px-0">
          <payment
            :focused="focused"
            :has-voucher="hasVoucher"
            :card-error="cardError"
            :counter="counter"
            :voucher="organizationVoucher"
            :name_card="new_organization.name_card"
            :updating-card="updatingCard"
            focus-enabled
            @card-confirmed="cardConfirmed"
            @toggle-voucher="toggleVoucher"
            @card-error="cardHasError"
            @change-voucher="changeVoucher"
            @change-focus="changeFocus"
          />
        </div>
      </validation-observer>
    </template>

    <template v-slot:footer>
      <b-button
        variant="bg-white"
        @click="onCancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="bg-primary"
        class="ml-1"
        @click="onSubmit()"
      >Save</b-button>
    </template>
  </form-wrapper>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Payment from '../helpers/Payment.vue'

export default {
  name: 'BillingEdit',
  components: {
    ValidationObserver,
    Payment,
  },
  data() {
    return {
      required,
      loading: true,
      cardName: '',
      cardElement: undefined,
      cardError: false,
      errorMessage: null,
      hasVoucher: true,
      editMessage: '',
      organizationVoucher: '',
      organizationId: null,
      new_organization: {},
      updatingCard: false,
      focused: false,
      counter: 0,
    }
  },
  computed: {
    organizations() {
      return this.$store.state.organization.organizations
    },
    organization() {
      return this.$store.state.organization.organization
    },
  },
  created() {
    this.organizationId = this.$route.params.organizationId
    this.$store.commit('app/SET_ORGANIZATION_ID', this.organizationId)

    this.$store
      .dispatch('organization/getOrganization', this.organizationId)
      .then(() => {
        if (this.organization.status === 1 || this.organization.hasVoucher) {
          this.updatingCard = true
          this.hasVoucher = false
        }
      })
      .catch(error => {
        this.editMessage = error.response?.data?.errors[0] || 'Something went wrong.'
      })
      .finally(() => { this.loading = false })
  },
  methods: {
    toggleVoucher(val) {
      this.hasVoucher = val
    },
    cardHasError(val) {
      this.cardError = val
    },
    changeVoucher(val) {
      this.organizationVoucher = val
    },
    changeFocus(val) {
      this.focused = val
    },

    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs.validation.validate().then(success => {
          if (!this.focused && this.organizationVoucher === '') {
            this.cardError = true
          }
          if (success) {
            if (!this.hasVoucher && this.cardError) {
              reject()
              return
            }
            if (this.hasVoucher) {
              this.updateOrganization()
            } else {
              this.addCard()
            }
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },

    updateOrganization() {
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      this.new_organization = this.$store.state.organization.organization
      this.new_organization.voucher = this.organizationVoucher
      this.$store
        .dispatch('organization/updateOrganization', this.new_organization)
        .then(() => {
          this.selectOrganization()
        })
        .catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating organization details.'))
        .finally(() => {
          this.$store.commit('app/TOGGLE_OVERLAY', false)
        })
    },

    addCard() {
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      this.$store
        .dispatch('payments/addPaymentMethod')
        .then(() => {
          this.counter++
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while adding billing details.')
          this.$store.commit('app/TOGGLE_OVERLAY', false)
        })
    },

    cardConfirmed() {
      this.$store
        .dispatch('organization/updateOrganization', { activate: true })
        .then(() => {
          this.selectOrganization()
        })
        .catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating organization details.'))
        .finally(() => this.$store.commit('app/TOGGLE_OVERLAY', false))
    },

    selectOrganization() {
      this.$store.commit('app/SET_ORGANIZATION_ID', this.organizationId)
      this.$router.push({ name: 'project', params: { projectId: null } })
    },

    onCancel() {
      this.$store.commit('app/SET_ORGANIZATION_ID', null)
      this.$router.push({ name: 'organization', query: this.$route.query })
    },
  },
}
</script>
